import React, { useEffect, useState, useMemo } from 'react'
import AdminLayout from '../../layouts/AdminLayout'
import {
    Box, Button, Text, Flex, HStack,
    Table, Thead, Tbody, Tr, Th, Td, TableContainer,
    FormControl, FormLabel, Grid, Input, Select, IconButton,
} from "@chakra-ui/react";
import { FaEdit, FaFileCsv, FaFilePdf } from "react-icons/fa";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import adminService from '../../services/adminService';
import ReactPaginate from "react-paginate";
import { exportToPDF } from '../../utils/pdfExporter';
import { exportToCSV } from '../../utils/csvExporter';

const validationSchema = Yup.object().shape({
    Country: Yup.string().required("Country is required"),
    City: Yup.string().required("City is required"),
    Stat: Yup.string().required("Stat is required"),
    CompCd: Yup.string().required("Company is required"),
});

const ITEMS_PER_PAGE = 10;

const Geofence = () => {

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
        setValue
    } = useForm({
        resolver: yupResolver(validationSchema),
    });

    const [data, setData] = useState([])
    const [cId, setCID] = useState(0)
    const [company, setCompany] = useState([])
    const [country, setCountry] = useState([])
    const [city, setCity] = useState([])

    const [search, setSearch] = useState("");
    const [page, setPage] = useState(0);
    const [sortField, setSortField] = useState(null);
    const [sortOrder, setSortOrder] = useState("asc");

    useEffect(() => {
        companyList();
        configList();
        countryList();
    }, [])

    const configList = async () => {
        try {
            const res = await adminService.getGeofenceList()

            if (res.statusCode === 200) {
                setData(res.data)
            }
        } catch (error) {
            alert(error.response?.data?.message || "Something went wrong.");
        }
    }

    const companyList = async () => {
        setCompany([])
        try {
            const res = await adminService.getCompany();
            if (res.statusCode === 200) {
                setCompany(res.data)
            }
        } catch (error) {
            alert(error.response?.data?.message || "Something went wrong.");
        }
    }

    const countryList = async () => {
        setCountry([])
        try {
            const res = await adminService.getCountry();
            if (res.statusCode === 200) {
                setCountry(res.data)
            }
        } catch (error) {
            alert(error.response?.data?.message || "Something went wrong.");
        }
    }

    const getCity = (e) => {
        const id = Number(e.target.value)
        if (id > 0) {
            cityList(id)
        }
    }

    const cityList = async (id) => {
        try {
            const res = await adminService.getCityByCountry(id);
            if (res.statusCode === 200) {
                setCity(res.data);
                return res.data; // ✅ return directly
            }
        } catch (error) {
            alert(error.response?.data?.message || "Something went wrong.");
        }
        return [];
    };

    const handleConfig = async (data) => {
        data.cId = cId;
        try {
            const res = await adminService.saveGeofence(data)

            setCID(0)
            if (res.statusCode === 200) {
                alert(res.message);
                reset();
                configList();
            }
        } catch (error) {
            alert(error.response?.data?.message || "Something went wrong.");
        }
    }

    const handleEdit = async (row) => {
        setValue("Country", row.Country);

        const cities = await cityList(row.Country);

        // Wait until city list is updated and ensure matching type
        setTimeout(() => {
            if (cities.some(c => String(c.city_id) === String(row.City))) {
                setValue("City", String(row.City));
            }
        }, 0);


        setValue("CompCd", row.CompCd);
        setValue("Stat", row.Stat);
        setCID(row.cId)


    };

    const filteredData = useMemo(() => {
        let result = [...data];
        if (search) {
            const lowerSearch = search.toLowerCase();
            result = result.filter((item) =>
            (`${item.name}`.toLowerCase().includes(lowerSearch) ||
                item.CompName.toLowerCase().includes(lowerSearch) ||
                String(item.Stat).includes(lowerSearch))
            );
        }
        if (sortField) {
            result.sort((a, b) => {
                let aVal = a[sortField] ?? '';
                let bVal = b[sortField] ?? '';

                return sortOrder === "asc" ? aVal > bVal ? 1 : -1 : aVal < bVal ? 1 : -1;
            });
        }
        return result;
    }, [data, search, sortField, sortOrder]);

    const pageCount = Math.ceil(filteredData.length / ITEMS_PER_PAGE);

    const currentData = useMemo(() => {
        const start = page * ITEMS_PER_PAGE;
        return filteredData.slice(start, start + ITEMS_PER_PAGE);
    }, [filteredData, page]);

    const handleSort = (field) => {
        if (sortField === field) {
            setSortOrder(sortOrder === "asc" ? "desc" : "asc");
        } else {
            setSortField(field);
            setSortOrder("asc");
        }
    };

    const handlePageChange = ({ selected }) => {
        setPage(selected);
    };

    const exportCSV = () => {
        // data, filename
        exportToCSV(filteredData, "geofence.csv")
    };

    const exportPDF = () => {
        const columns = [
            { label: "id", accessor: "cId" },
            { label: "Company", accessor: "CompName" },
            { label: "Country", accessor: "country_name" },
            { label: "City", accessor: "city_name" },
            { label: "Status", accessor: "Stat" },
        ];

        exportToPDF({
            data: filteredData,      // your actual data array
            columns,
            fileName: "geofence.pdf"
        });
    };

    return (
        <AdminLayout>
            <Box maxW="1000px" mx="auto" px={4}>
                {/* Form Section */}
                <Box
                    bg="white"
                    p={6}
                    rounded="xl"
                    boxShadow="md"
                    mb={3}
                    border="1px solid"
                    borderColor="gray.200"
                >
                    <form onSubmit={handleSubmit(handleConfig)}>
                        <Grid
                            templateColumns={{ base: "1fr", md: "repeat(3, 1fr)" }}
                            gap={6}
                        >
                            <FormControl >
                                <FormLabel fontSize="sm">Company</FormLabel>
                                <Select size="sm" {...register("CompCd")} >
                                    <option value={0}>Select</option>
                                    {company.map((row, i) => (
                                        <option value={row.CompCd} key={row.CompCd}>{row.Name}</option>
                                    ))}
                                </Select>
                                <Box color="red.500" fontSize="xs">
                                    {errors.CompCd?.message}
                                </Box>
                            </FormControl>

                            <FormControl >
                                <FormLabel fontSize="sm">Country</FormLabel>
                                <Select size="sm" {...register("Country")} onChange={getCity}>
                                    <option value={0}>Select</option>
                                    {country.map((row, i) => (
                                        <option value={row.id} key={row.id}>{row.country_name}</option>
                                    ))}
                                </Select>
                                <Box color="red.500" fontSize="xs">
                                    {errors.Country?.message}
                                </Box>
                            </FormControl>

                            <FormControl>
                                <FormLabel fontSize="sm">City</FormLabel>
                                <Select {...register("City")} size="sm">
                                    <option value="0">Select</option>
                                    {city.map((row) => (
                                        <option value={String(row.city_id)} key={row.city_id}>
                                            {row.city_name}
                                        </option>
                                    ))}
                                </Select>
                                <Box color="red.500" fontSize="xs">
                                    {errors.City?.message}
                                </Box>
                            </FormControl>

                            <FormControl>
                                <FormLabel fontSize="sm">Status</FormLabel>
                                <Select {...register("Stat")} size="sm">
                                    <option value={0}>Enable</option>
                                    <option value={1}>Disable</option>
                                </Select>
                                <Box color="red.500" fontSize="xs">
                                    {errors.Stat?.message}
                                </Box>
                            </FormControl>

                            <FormControl display="flex" flexDirection="column" justifyContent="flex-end">
                                <FormLabel>&nbsp;</FormLabel> {/* Keeps height consistent */}
                                <Button type="submit" colorScheme="blue" size="sm">
                                    Submit
                                </Button>
                            </FormControl>
                        </Grid>
                    </form>
                </Box>

                {/* Table + Controls Section */}
                <Box
                    bg="white"
                    p={6}
                    rounded="xl"
                    boxShadow="md"
                    border="1px solid"
                    borderColor="gray.200"
                >
                    <Flex justify="space-between" mb={4} flexWrap="wrap" gap={4}>
                        <Input
                            placeholder="Search by name..."
                            value={search}
                            onChange={(e) => {
                                setSearch(e.target.value);
                                setPage(0);
                            }}
                            maxW="300px"
                            size="sm"
                        />
                        <HStack>
                            <Button
                                size="sm"
                                colorScheme="blue"
                                leftIcon={<FaFileCsv />}
                                onClick={exportCSV}
                            >
                                CSV
                            </Button>
                            <Button
                                size="sm"
                                colorScheme="red"
                                leftIcon={<FaFilePdf />}
                                onClick={exportPDF}
                            >
                                PDF
                            </Button>
                        </HStack>
                    </Flex>

                    <TableContainer overflowX="auto">
                        <Table size="sm" variant="simple">
                            <Thead bg="gray.100">
                                <Tr>
                                    <Th px={2} py={1} cursor="pointer" onClick={() => handleSort("CompName")}>Company</Th>
                                    <Th px={2} py={1} cursor="pointer" onClick={() => handleSort("country_name")}>Country</Th>
                                    <Th px={2} py={1} cursor="pointer" onClick={() => handleSort("city_name")}>City</Th>
                                    <Th px={2} py={1} cursor="pointer" onClick={() => handleSort("Stat")}>Status</Th>
                                    <Th px={2} py={1}>Action</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {currentData.length > 0 ? (
                                    currentData.map((row) => (
                                        <Tr key={row.cId}>
                                            <Td px={2} py={1}>{row.CompName}</Td>
                                            <Td px={2} py={1}>{row.country_name}</Td>
                                            <Td px={2} py={1}>{row.city_name}</Td>
                                            <Td px={2} py={1}>{row.Stat === 0 ? "Enable" : "Disable"}</Td>
                                            <Td px={2} py={1}>
                                                <IconButton
                                                    icon={<FaEdit />}
                                                    aria-label="Edit"
                                                    borderRadius="full"
                                                    size="sm"
                                                    onClick={() => handleEdit(row)}
                                                />
                                            </Td>
                                        </Tr>
                                    ))
                                ) : (
                                    <Tr>
                                        <Td colSpan={4} px={2} py={1}>
                                            <Text textAlign="center">No data found</Text>
                                        </Td>
                                    </Tr>
                                )}
                            </Tbody>
                        </Table>
                    </TableContainer>

                </Box>

                <Box mt={6}>
                    <ReactPaginate
                        previousLabel="Previous"
                        nextLabel="Next"
                        pageCount={pageCount}
                        onPageChange={handlePageChange}
                        containerClassName="pagination"
                        activeClassName="active"
                        pageClassName="page-item"
                        previousClassName="page-item"
                        nextClassName="page-item"
                        breakClassName="page-item"
                        pageLinkClassName="page-link"
                        previousLinkClassName="page-link"
                        nextLinkClassName="page-link"
                        breakLinkClassName="page-link"
                    />
                </Box>

                <style>{`
                              .pagination {
                                display: flex;
                                justify-content: center;
                                list-style: none;
                                padding: 0;
                                margin-top: 1rem;
                              }
                              .page-item {
                                margin: 0 5px;
                              }
                              .page-link {
                                padding: 8px 12px;
                                border-radius: 6px;
                                background-color: #e2e8f0;
                                cursor: pointer;
                              }
                              .page-link:hover {
                                background-color: #cbd5e0;
                              }
                              .active .page-link {
                                background-color: #3182ce;
                                color: white;
                              }
                            `}</style>

            </Box>


        </AdminLayout >
    )
}

export default Geofence
